import {useState} from 'react'
import OrgWiseDeviceLockUnlockForm from './OrgWiseDeviceLockUnlockForm';
import OrgWiseDeviceLockUnlockList from './OrgWiseDeviceLockUnlockList';

const OrgWiseDeviceLockUnlock = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(null);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <OrgWiseDeviceLockUnlockForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <OrgWiseDeviceLockUnlockList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default OrgWiseDeviceLockUnlock